import { render, staticRenderFns } from "./portia.vue?vue&type=template&id=5e7d7ccc&scoped=true&"
import script from "./portia.vue?vue&type=script&lang=js&"
export * from "./portia.vue?vue&type=script&lang=js&"
import style0 from "./portia.vue?vue&type=style&index=0&id=5e7d7ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d7ccc",
  null
  
)

export default component.exports